<template>
  <div class="card">
    <div class="dataSubscriptionWrapper">
      <div class="container">
        <h4 class="text-center my-4">Security</h4>
        <div class="row justify-content-center my-4">
          <div class="col-12 col-md-4 d-flex justify-content-center">
            <button @click="ButtonClick('changePassword')" :class="buttons.changePassword.class">
              {{ buttons.changePassword.name }}
            </button>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-center">
            <button @click="ButtonClick('refreshToken')" :class="buttons.refreshToken.class">
              {{ buttons.refreshToken.name }}
            </button>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-center">
            <button @click="ButtonClick('apiKey')" :disabled="apiKeyButtonClicked"
              :class="[buttons.apiKey.class, apiKeyButtonClicked ? 'disabled' : '']"
              :style="apiKeyButtonClicked ? 'filter: grayscale(1)' : ''">
              <span v-if="apiKeyButtonClicked">
                <span>{{ buttons.apiKey.name }}</span>
                <div class="spinner-border spinner-border-sm ms-2"></div>
              </span>
              <span v-else>
                {{ buttons.apiKey.name }}
              </span>
            </button>
          </div>
        </div>
        <div v-show="showRefreshTokenButtonClicked">
          <ShowRefreshToken />
        </div>
        <div v-show="showApiButtonClicked">
          <ShowApiKey />
        </div>
        <div v-show="showChangePasswordButtonClicked">
          <ChangePassword :close="ToggleChangePassword" />
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.dataSubscriptionWrapper {
  padding: 10px;
}
</style>

<script>
import "mosha-vue-toastify/dist/style.css";
import { mapActions, mapGetters } from "vuex";
import {
  ChangePassword,
  ShowApiKey,
  ShowRefreshToken,
} from "../components/securityComponents/exporter.js";
import { Toaster, CopyToClipboard } from "../../../customFunctions/Utils.js";
import { SecurityContainerButtons } from "../staticData/exporter.js";

export default {
  name: "buttons-table",
  data() {
    return {
      showApiButtonClicked: false,
      showChangePasswordButtonClicked: false,
      showRefreshTokenButtonClicked: false,
      buttons: SecurityContainerButtons,
      apiKeyButtonClicked: false,
    };
  },
  components: {
    ChangePassword,
    ShowApiKey,
    ShowRefreshToken,
  },
  computed: {
    ...mapGetters([
      "getUserData",
      "getRefreshToken",
      "getApiKey",
      "getAccessToken",
    ]),
  },
  methods: {
    ...mapActions(["setApiKey"]),
    ButtonClick(buttonType) {
      switch (buttonType) {
        case 'changePassword':
          this.ToggleChangePassword();
          break;
        case 'refreshToken':
          this.ToggleRefreshToken();
          break;
        case 'apiKey':
          this.ToggleApiKey();
          break;
      }
    },
    ToggleChangePassword() {
      this.showChangePasswordButtonClicked = !this.showChangePasswordButtonClicked;
      if (this.showChangePasswordButtonClicked) {
        this.showApiButtonClicked = false;
        this.showRefreshTokenButtonClicked = false;
      }
    },
    ToggleRefreshToken() {
      this.showRefreshTokenButtonClicked = !this.showRefreshTokenButtonClicked;
      if (this.showRefreshTokenButtonClicked) {
        this.showApiButtonClicked = false;
        this.showChangePasswordButtonClicked = false;
      }
    },
    async ToggleApiKey() {
      if (!this.apiKeyButtonClicked) {
        this.apiKeyButtonClicked = true;
        await this.setApiKey(this.$store.state);
        this.showApiButtonClicked = !this.showApiButtonClicked;
        this.apiKeyButtonClicked = false;
        this.showChangePasswordButtonClicked = false;
        this.showRefreshTokenButtonClicked = false;
      } else {
        this.showApiButtonClicked = !this.showApiButtonClicked;
      }
    },
  },
  setup() {
    return { CopyToClipboard, Toaster };
  },
};
</script>

